import { useCallback, useState } from 'react';

export const useModalState = () => {
  const [showWarning, setShowWarning] = useState(false);

  const toggleModal = useCallback(() => {
    setShowWarning(!showWarning);
  }, [setShowWarning, showWarning]);

  const beforeUnloadHandler = (e: BeforeUnloadEvent) => {
    e.preventDefault();
    e.returnValue = true;
    return true;
  };

  return {
    showWarning,
    toggleModal,
    beforeUnloadHandler,
  };
};
